import { ContextType, Fragment, PureComponent } from "react";
import { Layer, Source } from "react-map-gl/mapbox-legacy";
import { LayerContext } from ".";

class MapLayer extends PureComponent<{
  rasterId: string;
}> {
  declare context: ContextType<typeof LayerContext>;
  render() {
    const { isLayerVisible } = this.context;

    const { rasterId } = this.props;

    const visibility = isLayerVisible({ group: "rasters", id: rasterId })
      ? "visible"
      : "none";

    const tiles = [
      `${window.env.APPLICATION_URL}/api/tiles/rasters/${rasterId}/{z}/{x}/{y}`,
    ];

    // const opacity = layerOpacityState({ groupId: "rasters" });

    return (
      <Fragment>
        <Source id={rasterId} tiles={tiles} type="raster" tileSize={256}>
          <Layer
            source={rasterId}
            type="raster"
            layout={{
              visibility,
            }}
            paint={{
              "raster-brightness-max": 1,
              "raster-brightness-min": 0,
              "raster-opacity": 1,
              "raster-hue-rotate": 0,
              "raster-saturation": 0,
              "raster-fade-duration": 0.3,
              "raster-resampling": "linear",
            }}
          ></Layer>
        </Source>
      </Fragment>
    );
  }
}

MapLayer.contextType = LayerContext;

export default MapLayer;
